import { inter } from "../../../shared/fonts/inter";
import { motion } from "motion/react";
import HeroBackgroundWork from "../background/HeroBackgroundWork";
import React from "react";
import AnimatedTitle from "../../../shared/animations/AnimatedTitle";
import { heroText } from "../../../../../data";
import HeroBackground from "../../homepage/background/HeroBackground";

const HeroWork = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[100vh] w-full justify-center"
      id="home"
      initial="initial"
      animate="animate"
    >
      {/* <HeroBackgroundWork /> */}
      <HeroBackground />
      <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <div
          className={`relative flex flex-col items-center justify-center ${inter.className} pointer-events-none`}
        >
          <AnimatedTitle
            text="Projekty"
            className="mb-10 text-left text-[40px] font-bold uppercase leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
            wordSpace={"mr-[10px]"}
            charSpace={"mr-[0.001em]"}
          />
        </div>
      </div>
    </motion.section>
  );
};

export default HeroWork;
